<template>
  <TableLayout :permissions="['business:integral:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="经销商名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入经销商名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="门店ID" prop="code">
        <el-input v-model="searchForm.code" placeholder="请输入门店ID" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button type="primary" :loading="isWorking.export" v-permissions="['business:shop:exportExcel']" @click="exportExcel">导出</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
      >
        <el-table-column prop="name" label="经销商名称" align="center" min-width="150px"> </el-table-column>
        <el-table-column prop="code" label="门店ID" align="center" min-width="150px"> </el-table-column>
        <el-table-column prop="amount" align="center" label="账户余额（元）" min-width="150px">
          <template slot-scope="{row}">{{row.amount || 0}}</template>
        </el-table-column>
        <el-table-column prop="jiesuanIng" align="center" label="待结算（元）" min-width="150px">
          <template slot-scope="{row}">{{row.jiesuanIng || 0}}</template>
        </el-table-column>
        <el-table-column prop="withdrawIng" align="center" label="提现中（元）" min-width="150px">
          <template slot-scope="{row}">{{row.withdrawIng || 0}}</template>
        </el-table-column>
        <el-table-column prop="withdrawTotal" align="center" label="累计提现（元）" min-width="150px">
          <template slot-scope="{row}">{{row.withdrawTotal || 0}}</template>
        </el-table-column>
        <el-table-column prop="withdrawDate" align="center" label="最近提现时间" min-width="150px"></el-table-column>
        <el-table-column
            label="操作"
            min-width="100"
            fixed="right"
            align="center"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.OperaIntegralShopMoneyWindow.open('查询经销商余额明细', row)" icon="el-icon-edit" >查询明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <OperaIntegralShopMoneyWindow ref="OperaIntegralShopMoneyWindow"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaIntegralShopMoneyWindow from '@/components/business/OperaIntegralShopMoneyWindow'
export default {
  name: 'Integral',
  extends: BaseTable,
  components: { TableLayout, Pagination ,OperaIntegralShopMoneyWindow},
  data () {
    return {
      createDate: [],
      // 搜索
      searchForm: {
        code: '',
        name: ''
      }
    }
  },
  created () {
    this.config({
      module: '经销商账户明细',
      api: '/business/shopMoney',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
  }
}
</script>
